<div class="ba-field-group">
    <div class="centered">
        <img [src]="asset('assets/images/icon-info-green.svg')" alt="icon info green">
    </div>
</div>
<h1 class="ibk-description centered">
    Lo sentimos
</h1>
<div class="ba-field-group centered">
    <span>Lamentablemente no puedes abrir la Cuenta Negocios por este medio debido a que no se ajusta a tu rubro. Por
        favor ac&eacute;rcarte a nuestra tienda principal en La Victoria y solicita mayor informaci&oacute;n.</span>
</div>
<div class="ba-field-group centered">
    <span>Lamentablemente no puedes abrir la Cuenta Negocios por este medio debido a que no se ajusta a tu rubro. Por
        favor, env&iacute;a un correo al buz&oacute;n <span
            class="text-primary underlined">atencioncuentanegocios@intercorp.com.pe</span> solicitando los requisitos
        para evaluar tu vinculaci&oacute;n al banco.</span>
</div>
<div class="centered border-communicate">
    <br />
    <br />
    <img [src]="asset('assets/images/communicate-icon.svg')" alt="communicate">
    <br />
    <br />
    <span>Lima</span>
    <br />
    <span class="f-s-20"><b>311 9001</b></span>
    <br />
    <br />
    <span>Provincias</span>
    <br />
    <span class="f-s-20"><b>0 801 00801</b></span>
    <br />
    <br />
    <span>De L - V de 8:30 am. a 7:00 pm.</span>
    <br />
    <span>S&aacute;bados: 8:30 am a 1:00 pm</span>
    <br />
    <br />
    <br />
</div>
<!-- <ibk-button class="ba-action" [loading]="isLoading">
    <button id="btn-resend-code" class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
        (click)="exitFlowCreateAccount.emit()">
        Salir
    </button>
</ibk-button> -->